const CATEGORY_TYPE = {
  TTS: 'TTS',
  PROJECT: 'PROJECT',
  DUBBING: 'DUBBING',
  VOICE_CLONING: 'VOICE_CLONING',
  PAYMENT: 'PAYMENT',
  AUTH: 'AUTH',
  OTHER: 'OTHER',
};

const PLATFORM_TYPE = {
  DESKTOP_WEB: 'DESKTOP_WEB',
  MOBILE_WEB: 'MOBILE_WEB',
  IOS: 'IOS',
  ANDROID: 'ANDROID',
};

export { CATEGORY_TYPE, PLATFORM_TYPE };
